import { useContext } from "react";

import { ConfettiContext } from "@/contexts/ConfettiContext";

export const useConfetti = () => {
    return useContext(ConfettiContext);
};
